import type { GetObligationImpactByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetObligationImpactByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObligationImpactByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetObligationImpactByIdArgs = { id: string };

export const useGetObligationImpactById = createQueryHook<
  UseGetObligationImpactByIdArgs,
  GetObligationImpactByIdResponseRow | null,
  GetObligationImpactByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.obligationImpact.getById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({
    obligation_impact: data
      ? [
          {
            __typename: 'obligation_impact',
            Id: data.Id,
            Description: data.Description,
            ImpactRating: data.ImpactRating,
            CustomAttributeData: data.CustomAttributeData,
          },
        ]
      : [],
  }),
  graphqlDocument: GetObligationImpactByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
  graphqlFetchPolicy: 'no-cache',
});
